// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__4_4uV","title":"AfterBackImages_title__9Qkyk","images":"AfterBackImages_images__e8teg"};